"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "patient-card" };
var _hoisted_2 = { class: "card-header" };
var _hoisted_3 = { class: "header-info" };
var _hoisted_4 = { class: "patient-name" };
var _hoisted_5 = { class: "mrn" };
var _hoisted_6 = { class: "menu-container" };
var _hoisted_7 = {
    key: 1,
    class: "menu-dropdown"
};
var _hoisted_8 = { class: "card-body" };
var _hoisted_9 = { class: "info-row" };
var _hoisted_10 = { class: "info-text" };
var _hoisted_11 = { class: "info-row" };
var _hoisted_12 = { class: "info-text email-text" };
var _hoisted_13 = { class: "info-row address-row" };
var _hoisted_14 = { class: "info-text" };
var _hoisted_15 = {
    key: 0,
    class: "tags-row"
};
var _hoisted_16 = {
    key: 1,
    class: "appointment-info"
};
var _hoisted_17 = {
    key: 0,
    class: "appointment-item"
};
var _hoisted_18 = { class: "appointment-date next" };
var _hoisted_19 = {
    key: 0,
    class: "appointment-provider"
};
var _hoisted_20 = {
    key: 1,
    class: "appointment-item"
};
var _hoisted_21 = { class: "appointment-date" };
var _hoisted_22 = {
    key: 0,
    class: "appointment-provider"
};
var _hoisted_23 = { class: "card-footer" };
var _hoisted_24 = ["disabled", "title"];
var _hoisted_25 = ["disabled", "title"];
var vue_3 = require("vue");
var patientCardsStore_1 = require("../../../stores/patientCardsStore");
var privileges_1 = require("@/stores/privileges");
var privileges_2 = require("@/constants/privileges");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PatCard',
    props: {
        patient: {}
    },
    emits: ["edit", "email", "sms", "call", "appointment"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        var showMenu = (0, vue_3.ref)(false);
        var appointment = (0, vue_3.computed)(function () { return store.getAppointmentForPatient(props.patient.id); });
        // keyon refuses a text or call to a patient without privilege 6
        // (keyon/lib/TwilioAccess.php), as NavigationBarTop does; say so on the card
        // instead of opening a modal whose send would be refused.
        var canCommunicateWithPatients = (0, vue_3.computed)(function () { return (0, privileges_1.usePrivilegesStore)().effectiveGranted(privileges_2.PRIVILEGES.COMMUNICATE_WITH_PATIENTS); });
        var contactTitle = (0, vue_3.computed)(function () { return canCommunicateWithPatients.value ? undefined : 'You do not have permission to text or call patients.'; });
        /*const initials = computed(() => {
          return `${props.patient.firstName[0]}${props.patient.lastName[0]}`.toUpperCase()
        })*/
        // Computed property for initials
        var initials = (0, vue_3.computed)(function () {
            var firstInitial = props.patient.firstName ? props.patient.firstName[0] : '';
            var lastInitial = props.patient.lastName ? props.patient.lastName[0] : '';
            return "".concat(firstInitial).concat(lastInitial).toUpperCase();
        });
        function formatDate(dateStr) {
            var date = new Date(dateStr);
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
        function handleEditClick() {
            showMenu.value = false;
            emit('edit', props.patient);
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "avatar",
                        style: (0, vue_2.normalizeStyle)({ background: _ctx.patient.avatarColor })
                    }, (0, vue_2.toDisplayString)(initials.value), 5),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.patient.lastName) + ", " + (0, vue_2.toDisplayString)(_ctx.patient.firstName), 1),
                        (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.patient.mrn), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "menu-btn",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (showMenu.value = !showMenu.value); })
                        }, __spreadArray([], (_cache[6] || (_cache[6] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical bi-three-dots-vertical" }, null, -1)
                        ])), true)),
                        (showMenu.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "menu-backdrop",
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (showMenu.value = false); })
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (showMenu.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "menu-item",
                                    onClick: handleEditClick
                                }, __spreadArray([], (_cache[7] || (_cache[7] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil bi-pencil" }, null, -1),
                                    (0, vue_2.createTextVNode)(" Edit Demographics ", -1)
                                ])), true))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, null, -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(_ctx.patient.phone), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                        _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, null, -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(_ctx.patient.email), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-map-marker" }, null, -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_14, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.patient.address.street), 1),
                            _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("br", null, null, -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.patient.address.city) + ", " + (0, vue_2.toDisplayString)(_ctx.patient.address.state) + " " + (0, vue_2.toDisplayString)(_ctx.patient.address.zip), 1)
                        ])
                    ]),
                    (_ctx.patient.tags && _ctx.patient.tags.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.patient.tags, function (tag) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                    key: tag,
                                    class: "tag"
                                }, (0, vue_2.toDisplayString)(tag), 1));
                            }), 128))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.patient.nextAppointment || _ctx.patient.lastVisit)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                            (_ctx.patient.nextAppointment)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, [
                                    _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("span", { class: "appointment-label" }, "Next Visit:", -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_18, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(formatDate(_ctx.patient.nextAppointment)) + " ", 1),
                                        (_ctx.patient.nextAppointmentWith)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_19, " with " + (0, vue_2.toDisplayString)(_ctx.patient.nextAppointmentWith), 1))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (_ctx.patient.lastVisit)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, [
                                    _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("span", { class: "appointment-label" }, "Last Visit:", -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_21, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(formatDate(_ctx.patient.lastVisit)) + " ", 1),
                                        (_ctx.patient.lastVisitWith)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_22, " with " + (0, vue_2.toDisplayString)(_ctx.patient.lastVisitWith), 1))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_23, [
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action email-action",
                        onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.$emit('email', _ctx.patient)); })
                    }, __spreadArray([], (_cache[14] || (_cache[14] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, null, -1),
                        (0, vue_2.createTextVNode)(" Email ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action sms-action",
                        disabled: !canCommunicateWithPatients.value,
                        title: contactTitle.value,
                        onClick: _cache[3] || (_cache[3] = function ($event) { return (_ctx.$emit('sms', _ctx.patient)); })
                    }, __spreadArray([], (_cache[15] || (_cache[15] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment" }, null, -1),
                        (0, vue_2.createTextVNode)(" Text ", -1)
                    ])), true), 8, _hoisted_24),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action call-action",
                        disabled: !canCommunicateWithPatients.value,
                        title: contactTitle.value,
                        onClick: _cache[4] || (_cache[4] = function ($event) { return (_ctx.$emit('call', _ctx.patient)); })
                    }, __spreadArray([], (_cache[16] || (_cache[16] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment bi-phone" }, null, -1),
                        (0, vue_2.createTextVNode)(" Call ", -1)
                    ])), true), 8, _hoisted_25),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action appt-action",
                        onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.$emit('appointment', _ctx.patient)); })
                    }, [
                        _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-calendar" }, null, -1)),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(appointment.value ? 'Manage' : 'Schedule'), 1)
                    ])
                ])
            ]));
        };
    }
});
